import { render, staticRenderFns } from "./CultivationDonutChart.vue?vue&type=template&id=3a49b512&scoped=true&"
import script from "./CultivationDonutChart.vue?vue&type=script&lang=js&"
export * from "./CultivationDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./CultivationDonutChart.vue?vue&type=style&index=0&id=3a49b512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a49b512",
  null
  
)

export default component.exports